import React, { ReactNode, SyntheticEvent } from 'react'
import cc from 'classcat'

import Icon from './Icon'
import styles from './Button.css'
import { MY_COMPUTER } from '../../util/dataTestIds'

export type ButtonProps = {
  theme?: string
  tagname?: string
  disabled?: boolean
  loading?: boolean
  onClick?: (e: SyntheticEvent) => void
  children: ReactNode
  icon?: string
  'data-id'?: string
  'data-test-id'?: string
  inverted?: boolean
  halfWidth?: boolean
  fileUpload?: boolean
  fullWidth?: boolean
  className?: string
  type?: string
  focus?: boolean
}

const defaultProps = {
  disabled: false,
  loading: false,
  onClick: () => {},
  'data-id': '',
  'data-test-id': '',
  icon: undefined,
  inverted: false,
  halfWidth: false,
  fullWidth: false,
  fileUpload: false,
  className: '',
}

const Button: React.FunctionComponent<ButtonProps> = ({
  tagname = 'button',
  children,
  onClick,
  icon,
  disabled,
  loading,
  fullWidth,
  halfWidth,
  inverted,
  fileUpload,
  className,
  'data-id': dataId,
  'data-test-id': dataTestId,
  type,
  focus,
}) => {
  const classNames = cc([
    styles.btn,
    className,
    {
      // LocalStyles       Prop
      [styles.focus]: focus,
      [styles.fullWidth]: fullWidth,
      [styles.inverted]: inverted,
      [styles.fileUpload]: fileUpload,
      [styles.halfWidth]: halfWidth,
      ['']: true,
    },
  ])

  return React.createElement(
    // `tagname` prop is added to resolve a bug exposed within FireFox.
    //  A <button /> that wraps an <input type="file" />
    //  renders the input not clickable.
    //  Allowing the tag to be a <div> resolves the issue.
    //  However ... transpiling "<tagname>" creates html tags
    //  called <tagname>.
    //  So - using pure JS for the Button wrapper component.
    tagname,
    {
      disabled,
      className: classNames,
      onClick: (e: SyntheticEvent) => {
        if (!disabled && !loading && onClick) {
          if (dataTestId !== MY_COMPUTER) {
            e.preventDefault()
          }
          onClick(e)
        }
      },
      'data-id': dataId,
      'data-test-id': dataTestId,
      type,
    },
    icon && <Icon name={icon} spin={loading} />,
    children
  )
}

Button.defaultProps = defaultProps

export default Button
